module.exports = __webpack_public_path__ + "img/color-companion-2_cn.f531fcd.jpg";